<template>
	<div class="realTimeAlarm">
		<div
			v-for="(item, i) in timeAlarm"
			:key="'timeAlarm' + i"
			class="flex align-center item">
			<img class="iconAlarm" :src="require(`@/assets/images/alarm/alarm_${i + 1}_${item.alarmTimesNum == 0 ? 1 : 3}.png`)" />
			<div
				class="flex flex-direction justify-center text-xsss"
				:class="{'text-pink': item.alarmTimesNum != 0}">
				{{ alarmTitle[i] }}
				<span class="text-xl" :class="{'text-pink': item.alarmTimesNum != 0}">{{ item.alarmTimesNum || 0 }}</span>
			</div>
		</div>
		<!-- <div class="flex align-center">
			<img class="margin-right-sm iconAlarm" src="~@/assets/images/index/temperatureAlarm.png" />
			<div class="flex flex-direction justify-center text-xsss text-white">
				消防系统
				<span class="text-xl text-pink">{{ timeAlarm[0].alarmTimesNum || 0 }}</span>
			</div>
		</div>
		<div class="flex align-center">
			<img class="margin-right-sm iconAlarm" src="~@/assets/images/index/batteryAlarm.png" />
			<div class="flex flex-direction justify-center text-xsss text-white">
				电池系统
				<span class="text-xl text-pink">{{ timeAlarm[1].alarmTimesNum || 0 }}</span>
			</div>
		</div>
		<div class="flex align-center">
			<img class="margin-right-sm iconAlarm" src="~@/assets/images/index/chargerAlarm.png" />
			<div class="flex flex-direction justify-center text-xsss text-white">
				换电系统
				<span class="text-xl text-yellow">{{ timeAlarm[2].alarmTimesNum || 0 }}</span>
			</div>
		</div>
		<div class="flex align-center">
			<img class="margin-right-sm iconAlarm" src="~@/assets/images/index/cameraAlarm.png" />
			<div class="flex flex-direction justify-center text-xsss text-white">
				站控系统
				<span class="text-xl text-pink">{{timeAlarm[3].alarmTimesNum||0}}</span>
			</div>
		</div>
		<div class="flex align-center">
			<img class="margin-right-sm iconAlarm" src="~@/assets/images/index/cameraAlarm.png" />
			<div class="flex flex-direction justify-center text-xsss text-white">
				充电系统
				<span class="text-xl text-pink">{{ timeAlarm[4].alarmTimesNum || 0 }}</span>
			</div>
		</div> -->
	</div>
</template>

<script>
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
	data() {
		return {
			timeAlarm: [],
			alarmTitle: ['消防系统', '电池系统', '换电系统', '站控系统', '充电系统'], 
		};
	},
	components: {},
	props: {},
    inject: ['cityUpdate'],
    computed: {
        computedProperty() {
        	return this.cityUpdate()
        }
    },
    watch: {
        computedProperty(val) {
			this.getData(val)
        },
    },
	mounted() {},
	methods: {
		// imgurl(i, item) {
		// 	return require(`~@/assets/images/alarm/alarm_${i + 1}_${item.alarmTimesNum ? 3 : 1}.png`)
		// },
		getData(data) {
			if (window.location.href.indexOf('singleSite') > -1) {
				this.selectStationActualTimeAlarm(data);
			} else {
				this.selectActualTimeAlarm(data);
			}
		},
		selectActualTimeAlarm(data = {}) {
			let _this = this;
			let params = {};
			if (data) {
				params = {
					"enCode": "TiDB-quanguo-shishigaojing",
					"@province": data.province || data.city || data.district
				}
			} else {
				params = {
					"enCode": "TiDB-quanguo-shishigaojing" //TiDB-全国-实时告警
				}
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					// 返回的第1条数据为消防系统
					// 返回的第2条数据为电池系统
					// 返回的第3条数据为换电系统
					// 返回的第4条数据为站控系统
					// 返回的第5条数据为充电系统
					if (!res) return;
					console.log("机器人告警", res)
					_this.timeAlarm = res;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		//站点
		selectStationActualTimeAlarm(data = {}) {
			let _this = this;

			let params = {
				"enCode": "TiDB-zhandian-shishigaojing", //TiDB-站点-实时告警
				'@station_id': data.stationId,
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					console.log("机器人告警", res)
					_this.timeAlarm = res;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	}
}
</script>
<style lang="scss" scoped>
.realTimeAlarm {
	width: 100%;
	background-color: #1a3342;
	display: flex;
	flex-wrap: wrap;

	.item {
		width: 20%;
		// padding-left: 20px;
		box-sizing: border-box;
		overflow: hidden;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		> div {
			text-align: center;
			margin-top: 10px;
		}
		.iconAlarm {
			width: 60px;
			height: 60px;
		}
		.text-xl {
			font-weight: bold;
			font-size: 50px;
		}
	}
}

</style>